import { PurchaseOrderLine } from 'tms-lib';

export interface PurchaseContractLine {
  id: string;
  contractNo: number;
  description: string;
  productKey: string;
  productDescription: string;
  unitOfMeasure: string;
  quantity: number;
  price: number;
  contractValue: number;
  contractLineBalanceValue: number;
  contractLineBalance: number;

  purchaseOrderLines: PurchaseOrderLine[];
}
